(function () {
    function initSimpleGallerySlider(section) {
        var slider = section.querySelector('.simple-gallery-slider__slider');

        if (!slider || typeof Swiper === 'undefined') {
            return;
        }

        new Swiper(slider, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            watchOverflow: false,
            speed: 600,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            centeredSlides: true,
            navigation: {
                prevEl: section.querySelector('.simple-gallery-slider__button--prev'),
                nextEl: section.querySelector('.simple-gallery-slider__button--next')
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('section.simple_gallery_slider').forEach(initSimpleGallerySlider);
    });
})();
